import billRequestApi from '@/api/billRequest/billRequestApi.js';

export default {
	name: 'bill-request-apply',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
            // billType:'',
            months:[],
			getBillRequestMonthsResp:'',
			applyInfo: {
				billRequestType:'',
				selectedMonths:[],
				email:''
			},
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
            
            let billTypeStr = 'INVOICE'; // default
            if ('invoice' == this.$route.query.billType) {
                billTypeStr = 'INVOICE';
            } else if ('invoiceSmall' == this.$route.query.billType) {
                billTypeStr = 'INVOICE_SMALL';
			}
			
			this.applyInfo.billRequestType = billTypeStr;

			this.getBillRequestMonthsResp = await billRequestApi.getBillRequestMonths(this.applyInfo.billRequestType);
			if (this.getBillRequestMonthsResp == null) {
				this.months = null;
				return;
			}
			this.months = this.getBillRequestMonthsResp.months;

			if (this.months != null) {
				// 按時間由近到遠排序
				this.months.sort(function(m1, m2){
					return m2 - m1;
				});
			}
		},

		async applySubmit() {

			// 使用者輸入驗證
			const isValid = await this.$validator.validate();	
			if(!isValid){
				return;
			}

			const applyBillRequestResp = await billRequestApi.applyBillRequest(this.applyInfo);

			if (applyBillRequestResp) {
				this.$router.push({ name: 'bill-request-result', params: { applyInfo: this.applyInfo } });
			}

		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billRequest/billRequestApply.js